module.exports = __webpack_public_path__ + "static/media/Artboard7.f9789911.png";